import { render, staticRenderFns } from "./MilkVatGeneralInfo.vue?vue&type=template&id=4da8edc2&"
import script from "./MilkVatGeneralInfo.vue?vue&type=script&lang=ts&"
export * from "./MilkVatGeneralInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports